export const sample_data = {
    "order": {
        "id": 5968074637634,
        "name": "#38446",
        "order_number": 38446,
        "email": "darwiisnputri@gmail.com",
        "_id": "66d3f0fc7635a88cc3d35f89",
        "closed_at": "2024-09-01T04:49:50.000Z",
        "created_at": "2024-09-01T04:43:34.000Z",
        "updated_at": "2024-09-01T05:16:26.000Z",
        "note": null,
        "total_price": "341.00",
        "subtotal_price": "341.00",
        "total_weight": 1000,
        "total_tax": "28.16",
        "currency": "SGD",
        "financial_status": "paid",
        "total_line_items_price": "356.00",
        "fulfillment_status": "fulfilled",
        "billing_address": {
            "first_name": "Muhammad",
            "address1": "Blk 574B, Woodlands Drive 16, #02-736",
            "phone": "+65 9467 4242",
            "city": "Singapore",
            "zip": "732574",
            "province": null,
            "country": "Singapore",
            "last_name": "Jabbar",
            "address2": null,
            "company": null,
            "latitude": 1.429532,
            "longitude": 103.7974626,
            "name": "Muhammad Jabbar",
            "country_code": "SG",
            "province_code": null
        },
        "shipping_address": {
            "first_name": "Muhammad",
            "address1": "Blk 574B, Woodlands Drive 16, #02-736",
            "phone": "+65 9467 4242",
            "city": "Singapore",
            "zip": "732574",
            "province": null,
            "country": "Singapore",
            "last_name": "Jabbar",
            "address2": null,
            "company": null,
            "latitude": 1.429532,
            "longitude": 103.7974626,
            "name": "Muhammad Jabbar",
            "country_code": "SG",
            "province_code": null
        },
        "customer": {
            "email": "darwiisnputri@gmail.com",
            "first_name": "Muhammad",
            "last_name": "Jabbar",
            "verified_email": true
        }
    },
    "shipment": {
        "_id": "66d3f0fcd5945fb6637d9a4c",
        "awb_no": "O5WZAPUCB7",
        "start_location": {
            "order_location": {},
            "shipment_location": "647f51a1f8469eddb58acbe5"
        },
        "end_location": {
            "order_location": {
                "title": "Customer's default",
                "latLng": "1.429532,103.7974626",
                "lat": "1.429532",
                "lng": "103.7974626"
            }
        },
        "due_date": "2024-09-01T04:46:01.426Z",
        "shipment_status": "OUT_FOR_DELIVERY"
    },
    "assigned_to": {
        "first_name": "Driver 3",
        "last_name": "BPS",
        "email": "driver3.bestperfumestore@gmail.com",
        "phone": "123345234",
        "_id": "6543800530981bd50ab6b610"
    },
    "shipment_items": [
        {
            "id": 15208925593922,
            "fulfillable_quantity": 1,
            "fulfillment_service": "manual",
            "fulfillment_status": "UNFULFILLED",
            "name": "X95",
            "price": "89.00",
            "product_exists": true,
            "product_id": 8812656689474,
            "sku": "TLC95",
            "title": "X95",
            "total_discount": "0.00",
            "variant_id": 47034631258434,
            "variant_inventory_management": "shopify",
            "variant_title": null,
            "vendor": "BestPerfume.Store",
            "picked_up": true,
            "item_status": "ACTIVE",
            "history": [
                {
                    "user_id": "6543800530981bd50ab6b610",
                    "metadata": {
                        "action": "SHIPMENT_ITEM_PICKED_UP",
                        "notes": "SHIPMENT -> PICKED UP",
                        "pickup_status": true,
                        "delivery_status": false,
                        "previous_picked_quantity": 0,
                        "current_picked_quantity": 1,
                        "previous_delivered_quantity": 0,
                        "current_delivered_quantity": 0,
                        "previous_return_quantity": 0,
                        "current_return_quantity": 0
                    },
                    "updated_at": "2024-09-01T05:40:50.024Z"
                }
            ],
            "image": {
                "id": 42902965911874,
                "position": 1,
                "product_id": 8812656689474,
                "width": 1300,
                "height": 1300,
                "alt": null,
                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x95.png?v=1696268914",
                "created_at": "2023-10-03T01:48:34+08:00",
                "updated_at": "2023-10-03T01:48:34+08:00",
                "admin_graphql_api_id": "gid://shopify/ProductImage/42902965911874",
                "variant_ids": []
            },
            "quantity": 1
        },
        {
            "id": 15208925626690,
            "fulfillable_quantity": 1,
            "fulfillment_service": "manual",
            "fulfillment_status": "UNFULFILLED",
            "name": "FREE Luxury Refillable Atomiser",
            "price": "0.00",
            "product_exists": true,
            "product_id": 8476207874370,
            "sku": "AC01",
            "title": "FREE Luxury Refillable Atomiser",
            "total_discount": "0.00",
            "variant_id": 45731893936450,
            "variant_inventory_management": "shopify",
            "variant_title": null,
            "vendor": "BestPerfume.Store",
            "picked_up": true,
            "item_status": "ACTIVE",
            "history": [
                {
                    "user_id": "6543800530981bd50ab6b610",
                    "metadata": {
                        "action": "SHIPMENT_ITEM_PICKED_UP",
                        "notes": "SHIPMENT -> PICKED UP",
                        "pickup_status": true,
                        "delivery_status": false,
                        "previous_picked_quantity": 0,
                        "current_picked_quantity": 1,
                        "previous_delivered_quantity": 0,
                        "current_delivered_quantity": 0,
                        "previous_return_quantity": 0,
                        "current_return_quantity": 0
                    },
                    "updated_at": "2024-09-01T05:40:50.025Z"
                }
            ],
            "image": {
                "id": 43375725936962,
                "position": 1,
                "product_id": 8476207874370,
                "width": 960,
                "height": 1080,
                "alt": null,
                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/luxuryperfumeatomiser.png?v=1700300379",
                "created_at": "2023-11-18T17:39:39+08:00",
                "updated_at": "2023-11-18T17:39:39+08:00",
                "admin_graphql_api_id": "gid://shopify/ProductImage/43375725936962",
                "variant_ids": []
            },
            "quantity": 1
        },
        {
            "id": 15208925659458,
            "fulfillable_quantity": 1,
            "fulfillment_service": "manual",
            "fulfillment_status": "UNFULFILLED",
            "name": "X54",
            "price": "89.00",
            "product_exists": true,
            "product_id": 8465409016130,
            "sku": "TLC54",
            "title": "X54",
            "total_discount": "0.00",
            "variant_id": 45670043615554,
            "variant_inventory_management": "shopify",
            "variant_title": null,
            "vendor": "BestPerfume.Store",
            "picked_up": true,
            "item_status": "ACTIVE",
            "history": [
                {
                    "user_id": "6543800530981bd50ab6b610",
                    "metadata": {
                        "action": "SHIPMENT_ITEM_PICKED_UP",
                        "notes": "SHIPMENT -> PICKED UP",
                        "pickup_status": true,
                        "delivery_status": false,
                        "previous_picked_quantity": 0,
                        "current_picked_quantity": 1,
                        "previous_delivered_quantity": 0,
                        "current_delivered_quantity": 0,
                        "previous_return_quantity": 0,
                        "current_return_quantity": 0
                    },
                    "updated_at": "2024-09-01T05:40:50.025Z"
                }
            ],
            "image": {
                "id": 42032937959746,
                "position": 1,
                "product_id": 8465409016130,
                "width": 1300,
                "height": 1300,
                "alt": null,
                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x54.png?v=1689729448",
                "created_at": "2023-07-19T09:17:28+08:00",
                "updated_at": "2023-07-19T09:17:28+08:00",
                "admin_graphql_api_id": "gid://shopify/ProductImage/42032937959746",
                "variant_ids": []
            },
            "quantity": 1
        },
        {
            "id": 15208925692226,
            "fulfillable_quantity": 1,
            "fulfillment_service": "manual",
            "fulfillment_status": "UNFULFILLED",
            "name": "X30",
            "price": "89.00",
            "product_exists": true,
            "product_id": 8465411506498,
            "sku": "TLC30",
            "title": "X30",
            "total_discount": "0.00",
            "variant_id": 45670051512642,
            "variant_inventory_management": "shopify",
            "variant_title": null,
            "vendor": "BestPerfume.Store",
            "picked_up": true,
            "item_status": "ACTIVE",
            "history": [
                {
                    "user_id": "6543800530981bd50ab6b610",
                    "metadata": {
                        "action": "SHIPMENT_ITEM_PICKED_UP",
                        "notes": "SHIPMENT -> PICKED UP",
                        "pickup_status": true,
                        "delivery_status": false,
                        "previous_picked_quantity": 0,
                        "current_picked_quantity": 1,
                        "previous_delivered_quantity": 0,
                        "current_delivered_quantity": 0,
                        "previous_return_quantity": 0,
                        "current_return_quantity": 0
                    },
                    "updated_at": "2024-09-01T05:40:50.025Z"
                }
            ],
            "image": {
                "id": 42032900604226,
                "position": 1,
                "product_id": 8465411506498,
                "width": 1300,
                "height": 1300,
                "alt": null,
                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x30.png?v=1689729136",
                "created_at": "2023-07-19T09:12:16+08:00",
                "updated_at": "2023-07-19T09:12:16+08:00",
                "admin_graphql_api_id": "gid://shopify/ProductImage/42032900604226",
                "variant_ids": []
            },
            "quantity": 1
        },
        {
            "id": 15208925724994,
            "fulfillable_quantity": 1,
            "fulfillment_service": "manual",
            "fulfillment_status": "UNFULFILLED",
            "name": "X01 - Adjusted for Heat (X01)",
            "price": "89.00",
            "product_exists": true,
            "product_id": 8465414357314,
            "sku": "TLC01",
            "title": "X01",
            "total_discount": "0.00",
            "variant_id": 46421151056194,
            "variant_inventory_management": "shopify",
            "variant_title": "Adjusted for Heat (X01)",
            "vendor": "BestPerfume.Store",
            "picked_up": true,
            "item_status": "ACTIVE",
            "history": [
                {
                    "user_id": "6543800530981bd50ab6b610",
                    "metadata": {
                        "action": "SHIPMENT_ITEM_PICKED_UP",
                        "notes": "SHIPMENT -> PICKED UP",
                        "pickup_status": true,
                        "delivery_status": false,
                        "previous_picked_quantity": 0,
                        "current_picked_quantity": 1,
                        "previous_delivered_quantity": 0,
                        "current_delivered_quantity": 0,
                        "previous_return_quantity": 0,
                        "current_return_quantity": 0
                    },
                    "updated_at": "2024-09-01T05:40:50.025Z"
                }
            ],
            "image": {
                "id": 42032825467202,
                "position": 1,
                "product_id": 8465414357314,
                "width": 1300,
                "height": 1300,
                "alt": null,
                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x01.png?v=1692971586",
                "created_at": "2023-07-19T09:01:38+08:00",
                "updated_at": "2023-08-25T21:53:06+08:00",
                "admin_graphql_api_id": "gid://shopify/ProductImage/42032825467202",
                "variant_ids": []
            },
            "quantity": 1
        }
    ],
    "shipment_history": [
        {
            "_id": "66d43ff7f7486410fc7dbf39",
            "user_id": "6543800530981bd50ab6b610",
            "shipment_id": "66d3f0fcd5945fb6637d9a4c",
            "action_type": "SHIPMENT",
            "updated_status": "OUT_FOR_DELIVERY",
            "previous_status": "OUT_FOR_DELIVERY",
            "notes": "SHIPMENT -> UPDATED",
            "custom_notes": "",
            "reschedule_date": "",
            "diff_metadata": {
                "added": [],
                "removed": [],
                "edited": []
            },
            "restore_metadata": [],
            "updated_at": "2024-09-01T10:20:39.133Z",
            "isArcheived": false,
            "tenant_id": "647f5198df12d9c3626610e2",
            "createdAt": "2024-09-01T10:20:39.134Z",
            "updatedAt": "2024-09-01T10:20:39.134Z",
            "__v": 0
        },
        {
            "_id": "66d3fe629af51ccfdf43610a",
            "user_id": "6543800530981bd50ab6b610",
            "shipment_id": "66d3f0fcd5945fb6637d9a4c",
            "action_type": "SHIPMENT",
            "updated_status": "PICKED_UP",
            "previous_status": "PICKED_UP",
            "notes": "SHIPMENT -> PICKED UP",
            "custom_notes": "",
            "reschedule_date": "",
            "diff_metadata": {
                "added": [],
                "removed": [],
                "edited": []
            },
            "restore_metadata": [],
            "updated_at": "2024-09-01T05:40:50.107Z",
            "isArcheived": false,
            "tenant_id": "647f5198df12d9c3626610e2",
            "createdAt": "2024-09-01T05:40:50.108Z",
            "updatedAt": "2024-09-01T05:40:50.108Z",
            "__v": 0
        },
        {
            "_id": "66d3f0fc7635a88cc3d35fa2",
            "shipment_id": "66d3f0fcd5945fb6637d9a4c",
            "action_type": "SHIPMENT",
            "updated_status": "NEW",
            "previous_status": "",
            "notes": "SHIPMENT -> CREATED",
            "custom_notes": "",
            "reschedule_date": "",
            "diff_metadata": {
                "added": [
                    [
                        "start_location",
                        {}
                    ],
                    [
                        "start_location/shipment_location",
                        "647f51a1f8469eddb58acbe5"
                    ],
                    [
                        "end_location",
                        {}
                    ],
                    [
                        "end_location/order_location",
                        {}
                    ],
                    [
                        "end_location/order_location/title",
                        "Customer's default"
                    ],
                    [
                        "end_location/order_location/latLng",
                        "1.429532,103.7974626"
                    ],
                    [
                        "end_location/order_location/lat",
                        "1.429532"
                    ],
                    [
                        "end_location/order_location/lng",
                        "103.7974626"
                    ],
                    [
                        "delivery_timeslot",
                        {}
                    ],
                    [
                        "delivery_timeslot/title",
                        ""
                    ],
                    [
                        "delivery_timeslot/date",
                        null
                    ],
                    [
                        "delivery_timeslot/start",
                        0
                    ],
                    [
                        "delivery_timeslot/end",
                        1440
                    ],
                    [
                        "_id",
                        "66d3f0fcd5945fb6637d9a4c"
                    ],
                    [
                        "order",
                        "66d3f0fc7635a88cc3d35f89"
                    ],
                    [
                        "tenant_id",
                        "647f5198df12d9c3626610e2"
                    ],
                    [
                        "__v",
                        0
                    ],
                    [
                        "action_needed",
                        false
                    ],
                    [
                        "awb_no",
                        "O5WZAPUCB7"
                    ],
                    [
                        "claimable",
                        false
                    ],
                    [
                        "createdAt",
                        "2024-09-01T04:43:34.000Z"
                    ],
                    [
                        "delivery_metadata",
                        {}
                    ],
                    [
                        "delivery_metadata/delivery_date",
                        null
                    ],
                    [
                        "delivery_metadata/pincode",
                        ""
                    ],
                    [
                        "delivery_metadata/location_id",
                        ""
                    ],
                    [
                        "delivery_metadata/location_title",
                        ""
                    ],
                    [
                        "delivery_metadata/slot_id",
                        ""
                    ],
                    [
                        "delivery_metadata/slot_title",
                        ""
                    ],
                    [
                        "delivery_method",
                        "LOCAL_DELIVERY"
                    ],
                    [
                        "isArcheived",
                        false
                    ],
                    [
                        "items",
                        []
                    ],
                    [
                        "items/0[]",
                        {}
                    ],
                    [
                        "items/0[]/id",
                        15208925593922
                    ],
                    [
                        "items/0[]/admin_graphql_api_id",
                        "gid://shopify/LineItem/15208925593922"
                    ],
                    [
                        "items/0[]/attributed_staffs",
                        []
                    ],
                    [
                        "items/0[]/fulfillable_quantity",
                        1
                    ],
                    [
                        "items/0[]/fulfillment_service",
                        "manual"
                    ],
                    [
                        "items/0[]/fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/0[]/gift_card",
                        false
                    ],
                    [
                        "items/0[]/grams",
                        250
                    ],
                    [
                        "items/0[]/name",
                        "X95"
                    ],
                    [
                        "items/0[]/price",
                        "89.00"
                    ],
                    [
                        "items/0[]/price_set",
                        {}
                    ],
                    [
                        "items/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/0[]/price_set/shop_money/amount",
                        "89.00"
                    ],
                    [
                        "items/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/0[]/price_set/presentment_money/amount",
                        "89.00"
                    ],
                    [
                        "items/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/product_exists",
                        true
                    ],
                    [
                        "items/0[]/product_id",
                        8812656689474
                    ],
                    [
                        "items/0[]/product_type",
                        "Perfume"
                    ],
                    [
                        "items/0[]/properties",
                        []
                    ],
                    [
                        "items/0[]/properties/0[]",
                        {}
                    ],
                    [
                        "items/0[]/properties/0[]/name",
                        "THIS IS A GIFT"
                    ],
                    [
                        "items/0[]/properties/0[]/value",
                        "No"
                    ],
                    [
                        "items/0[]/requires_shipping",
                        true
                    ],
                    [
                        "items/0[]/sku",
                        "TLC95"
                    ],
                    [
                        "items/0[]/taxable",
                        true
                    ],
                    [
                        "items/0[]/title",
                        "X95"
                    ],
                    [
                        "items/0[]/total_discount",
                        "0.00"
                    ],
                    [
                        "items/0[]/total_discount_set",
                        {}
                    ],
                    [
                        "items/0[]/total_discount_set/shop_money",
                        {}
                    ],
                    [
                        "items/0[]/total_discount_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/0[]/total_discount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/total_discount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/0[]/total_discount_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/0[]/total_discount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/variant_id",
                        47034631258434
                    ],
                    [
                        "items/0[]/variant_inventory_management",
                        "shopify"
                    ],
                    [
                        "items/0[]/variant_title",
                        null
                    ],
                    [
                        "items/0[]/vendor",
                        "BestPerfume.Store"
                    ],
                    [
                        "items/0[]/tax_lines",
                        []
                    ],
                    [
                        "items/0[]/tax_lines/0[]",
                        {}
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price",
                        "7.04"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/rate",
                        0.09
                    ],
                    [
                        "items/0[]/tax_lines/0[]/title",
                        "GST"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set",
                        {}
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/shop_money/amount",
                        "7.04"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/presentment_money/amount",
                        "7.04"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/channel_liable",
                        false
                    ],
                    [
                        "items/0[]/duties",
                        []
                    ],
                    [
                        "items/0[]/discount_allocations",
                        []
                    ],
                    [
                        "items/0[]/discount_allocations/0[]",
                        {}
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount",
                        "3.75"
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set",
                        {}
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/shop_money",
                        {}
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/shop_money/amount",
                        "3.75"
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/presentment_money/amount",
                        "3.75"
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/discount_application_index",
                        0
                    ],
                    [
                        "items/0[]/image",
                        {}
                    ],
                    [
                        "items/0[]/image/id",
                        42902965911874
                    ],
                    [
                        "items/0[]/image/position",
                        1
                    ],
                    [
                        "items/0[]/image/product_id",
                        8812656689474
                    ],
                    [
                        "items/0[]/image/width",
                        1300
                    ],
                    [
                        "items/0[]/image/height",
                        1300
                    ],
                    [
                        "items/0[]/image/alt",
                        null
                    ],
                    [
                        "items/0[]/image/src",
                        "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x95.png?v=1696268914"
                    ],
                    [
                        "items/0[]/image/created_at",
                        "2023-10-03T01:48:34+08:00"
                    ],
                    [
                        "items/0[]/image/updated_at",
                        "2023-10-03T01:48:34+08:00"
                    ],
                    [
                        "items/0[]/image/admin_graphql_api_id",
                        "gid://shopify/ProductImage/42902965911874"
                    ],
                    [
                        "items/0[]/image/variant_ids",
                        []
                    ],
                    [
                        "items/0[]/quantity",
                        1
                    ],
                    [
                        "items/0[]/picked_quantity",
                        0
                    ],
                    [
                        "items/0[]/delivered_quantity",
                        0
                    ],
                    [
                        "items/0[]/return_quantity",
                        0
                    ],
                    [
                        "items/0[]/lmd_fulfillable_quantity",
                        0
                    ],
                    [
                        "items/0[]/lmd_fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/0[]/item_status",
                        "ACTIVE"
                    ],
                    [
                        "items/0[]/picked_up",
                        false
                    ],
                    [
                        "items/0[]/_id",
                        "66d3f0fc7635a88cc3d35f8a"
                    ],
                    [
                        "items/0[]/history",
                        []
                    ],
                    [
                        "items/1[]",
                        {}
                    ],
                    [
                        "items/1[]/id",
                        15208925626690
                    ],
                    [
                        "items/1[]/admin_graphql_api_id",
                        "gid://shopify/LineItem/15208925626690"
                    ],
                    [
                        "items/1[]/attributed_staffs",
                        []
                    ],
                    [
                        "items/1[]/fulfillable_quantity",
                        1
                    ],
                    [
                        "items/1[]/fulfillment_service",
                        "manual"
                    ],
                    [
                        "items/1[]/fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/1[]/gift_card",
                        false
                    ],
                    [
                        "items/1[]/grams",
                        0
                    ],
                    [
                        "items/1[]/name",
                        "FREE Luxury Refillable Atomiser"
                    ],
                    [
                        "items/1[]/price",
                        "0.00"
                    ],
                    [
                        "items/1[]/price_set",
                        {}
                    ],
                    [
                        "items/1[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/1[]/price_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/1[]/price_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/product_exists",
                        true
                    ],
                    [
                        "items/1[]/product_id",
                        8476207874370
                    ],
                    [
                        "items/1[]/product_type",
                        "Gift"
                    ],
                    [
                        "items/1[]/properties",
                        []
                    ],
                    [
                        "items/1[]/requires_shipping",
                        true
                    ],
                    [
                        "items/1[]/sku",
                        "AC01"
                    ],
                    [
                        "items/1[]/taxable",
                        true
                    ],
                    [
                        "items/1[]/title",
                        "FREE Luxury Refillable Atomiser"
                    ],
                    [
                        "items/1[]/total_discount",
                        "0.00"
                    ],
                    [
                        "items/1[]/total_discount_set",
                        {}
                    ],
                    [
                        "items/1[]/total_discount_set/shop_money",
                        {}
                    ],
                    [
                        "items/1[]/total_discount_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/total_discount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/total_discount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/1[]/total_discount_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/total_discount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/variant_id",
                        45731893936450
                    ],
                    [
                        "items/1[]/variant_inventory_management",
                        "shopify"
                    ],
                    [
                        "items/1[]/variant_title",
                        null
                    ],
                    [
                        "items/1[]/vendor",
                        "BestPerfume.Store"
                    ],
                    [
                        "items/1[]/tax_lines",
                        []
                    ],
                    [
                        "items/1[]/tax_lines/0[]",
                        {}
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price",
                        "0.00"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/rate",
                        0.09
                    ],
                    [
                        "items/1[]/tax_lines/0[]/title",
                        "GST"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set",
                        {}
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/channel_liable",
                        false
                    ],
                    [
                        "items/1[]/duties",
                        []
                    ],
                    [
                        "items/1[]/discount_allocations",
                        []
                    ],
                    [
                        "items/1[]/image",
                        {}
                    ],
                    [
                        "items/1[]/image/id",
                        43375725936962
                    ],
                    [
                        "items/1[]/image/position",
                        1
                    ],
                    [
                        "items/1[]/image/product_id",
                        8476207874370
                    ],
                    [
                        "items/1[]/image/width",
                        960
                    ],
                    [
                        "items/1[]/image/height",
                        1080
                    ],
                    [
                        "items/1[]/image/alt",
                        null
                    ],
                    [
                        "items/1[]/image/src",
                        "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/luxuryperfumeatomiser.png?v=1700300379"
                    ],
                    [
                        "items/1[]/image/created_at",
                        "2023-11-18T17:39:39+08:00"
                    ],
                    [
                        "items/1[]/image/updated_at",
                        "2023-11-18T17:39:39+08:00"
                    ],
                    [
                        "items/1[]/image/admin_graphql_api_id",
                        "gid://shopify/ProductImage/43375725936962"
                    ],
                    [
                        "items/1[]/image/variant_ids",
                        []
                    ],
                    [
                        "items/1[]/quantity",
                        1
                    ],
                    [
                        "items/1[]/picked_quantity",
                        0
                    ],
                    [
                        "items/1[]/delivered_quantity",
                        0
                    ],
                    [
                        "items/1[]/return_quantity",
                        0
                    ],
                    [
                        "items/1[]/lmd_fulfillable_quantity",
                        0
                    ],
                    [
                        "items/1[]/lmd_fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/1[]/item_status",
                        "ACTIVE"
                    ],
                    [
                        "items/1[]/picked_up",
                        false
                    ],
                    [
                        "items/1[]/_id",
                        "66d3f0fc7635a88cc3d35f8c"
                    ],
                    [
                        "items/1[]/history",
                        []
                    ],
                    [
                        "items/2[]",
                        {}
                    ],
                    [
                        "items/2[]/id",
                        15208925659458
                    ],
                    [
                        "items/2[]/admin_graphql_api_id",
                        "gid://shopify/LineItem/15208925659458"
                    ],
                    [
                        "items/2[]/attributed_staffs",
                        []
                    ],
                    [
                        "items/2[]/fulfillable_quantity",
                        1
                    ],
                    [
                        "items/2[]/fulfillment_service",
                        "manual"
                    ],
                    [
                        "items/2[]/fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/2[]/gift_card",
                        false
                    ],
                    [
                        "items/2[]/grams",
                        250
                    ],
                    [
                        "items/2[]/name",
                        "X54"
                    ],
                    [
                        "items/2[]/price",
                        "89.00"
                    ],
                    [
                        "items/2[]/price_set",
                        {}
                    ],
                    [
                        "items/2[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/2[]/price_set/shop_money/amount",
                        "89.00"
                    ],
                    [
                        "items/2[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/2[]/price_set/presentment_money/amount",
                        "89.00"
                    ],
                    [
                        "items/2[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/product_exists",
                        true
                    ],
                    [
                        "items/2[]/product_id",
                        8465409016130
                    ],
                    [
                        "items/2[]/product_type",
                        "Perfume"
                    ],
                    [
                        "items/2[]/properties",
                        []
                    ],
                    [
                        "items/2[]/properties/0[]",
                        {}
                    ],
                    [
                        "items/2[]/properties/0[]/name",
                        "THIS IS A GIFT"
                    ],
                    [
                        "items/2[]/properties/0[]/value",
                        "No"
                    ],
                    [
                        "items/2[]/requires_shipping",
                        true
                    ],
                    [
                        "items/2[]/sku",
                        "TLC54"
                    ],
                    [
                        "items/2[]/taxable",
                        true
                    ],
                    [
                        "items/2[]/title",
                        "X54"
                    ],
                    [
                        "items/2[]/total_discount",
                        "0.00"
                    ],
                    [
                        "items/2[]/total_discount_set",
                        {}
                    ],
                    [
                        "items/2[]/total_discount_set/shop_money",
                        {}
                    ],
                    [
                        "items/2[]/total_discount_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/2[]/total_discount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/total_discount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/2[]/total_discount_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/2[]/total_discount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/variant_id",
                        45670043615554
                    ],
                    [
                        "items/2[]/variant_inventory_management",
                        "shopify"
                    ],
                    [
                        "items/2[]/variant_title",
                        null
                    ],
                    [
                        "items/2[]/vendor",
                        "BestPerfume.Store"
                    ],
                    [
                        "items/2[]/tax_lines",
                        []
                    ],
                    [
                        "items/2[]/tax_lines/0[]",
                        {}
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price",
                        "7.04"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/rate",
                        0.09
                    ],
                    [
                        "items/2[]/tax_lines/0[]/title",
                        "GST"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set",
                        {}
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/shop_money/amount",
                        "7.04"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/presentment_money/amount",
                        "7.04"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/channel_liable",
                        false
                    ],
                    [
                        "items/2[]/duties",
                        []
                    ],
                    [
                        "items/2[]/discount_allocations",
                        []
                    ],
                    [
                        "items/2[]/discount_allocations/0[]",
                        {}
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount",
                        "3.75"
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set",
                        {}
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/shop_money",
                        {}
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/shop_money/amount",
                        "3.75"
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/presentment_money/amount",
                        "3.75"
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/discount_application_index",
                        0
                    ],
                    [
                        "items/2[]/image",
                        {}
                    ],
                    [
                        "items/2[]/image/id",
                        42032937959746
                    ],
                    [
                        "items/2[]/image/position",
                        1
                    ],
                    [
                        "items/2[]/image/product_id",
                        8465409016130
                    ],
                    [
                        "items/2[]/image/width",
                        1300
                    ],
                    [
                        "items/2[]/image/height",
                        1300
                    ],
                    [
                        "items/2[]/image/alt",
                        null
                    ],
                    [
                        "items/2[]/image/src",
                        "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x54.png?v=1689729448"
                    ],
                    [
                        "items/2[]/image/created_at",
                        "2023-07-19T09:17:28+08:00"
                    ],
                    [
                        "items/2[]/image/updated_at",
                        "2023-07-19T09:17:28+08:00"
                    ],
                    [
                        "items/2[]/image/admin_graphql_api_id",
                        "gid://shopify/ProductImage/42032937959746"
                    ],
                    [
                        "items/2[]/image/variant_ids",
                        []
                    ],
                    [
                        "items/2[]/quantity",
                        1
                    ],
                    [
                        "items/2[]/picked_quantity",
                        0
                    ],
                    [
                        "items/2[]/delivered_quantity",
                        0
                    ],
                    [
                        "items/2[]/return_quantity",
                        0
                    ],
                    [
                        "items/2[]/lmd_fulfillable_quantity",
                        0
                    ],
                    [
                        "items/2[]/lmd_fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/2[]/item_status",
                        "ACTIVE"
                    ],
                    [
                        "items/2[]/picked_up",
                        false
                    ],
                    [
                        "items/2[]/_id",
                        "66d3f0fc7635a88cc3d35f8d"
                    ],
                    [
                        "items/2[]/history",
                        []
                    ],
                    [
                        "items/3[]",
                        {}
                    ],
                    [
                        "items/3[]/id",
                        15208925692226
                    ],
                    [
                        "items/3[]/admin_graphql_api_id",
                        "gid://shopify/LineItem/15208925692226"
                    ],
                    [
                        "items/3[]/attributed_staffs",
                        []
                    ],
                    [
                        "items/3[]/fulfillable_quantity",
                        1
                    ],
                    [
                        "items/3[]/fulfillment_service",
                        "manual"
                    ],
                    [
                        "items/3[]/fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/3[]/gift_card",
                        false
                    ],
                    [
                        "items/3[]/grams",
                        250
                    ],
                    [
                        "items/3[]/name",
                        "X30"
                    ],
                    [
                        "items/3[]/price",
                        "89.00"
                    ],
                    [
                        "items/3[]/price_set",
                        {}
                    ],
                    [
                        "items/3[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/3[]/price_set/shop_money/amount",
                        "89.00"
                    ],
                    [
                        "items/3[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/3[]/price_set/presentment_money/amount",
                        "89.00"
                    ],
                    [
                        "items/3[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/product_exists",
                        true
                    ],
                    [
                        "items/3[]/product_id",
                        8465411506498
                    ],
                    [
                        "items/3[]/product_type",
                        "Perfume"
                    ],
                    [
                        "items/3[]/properties",
                        []
                    ],
                    [
                        "items/3[]/properties/0[]",
                        {}
                    ],
                    [
                        "items/3[]/properties/0[]/name",
                        "THIS IS A GIFT"
                    ],
                    [
                        "items/3[]/properties/0[]/value",
                        "No"
                    ],
                    [
                        "items/3[]/requires_shipping",
                        true
                    ],
                    [
                        "items/3[]/sku",
                        "TLC30"
                    ],
                    [
                        "items/3[]/taxable",
                        true
                    ],
                    [
                        "items/3[]/title",
                        "X30"
                    ],
                    [
                        "items/3[]/total_discount",
                        "0.00"
                    ],
                    [
                        "items/3[]/total_discount_set",
                        {}
                    ],
                    [
                        "items/3[]/total_discount_set/shop_money",
                        {}
                    ],
                    [
                        "items/3[]/total_discount_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/3[]/total_discount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/total_discount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/3[]/total_discount_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/3[]/total_discount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/variant_id",
                        45670051512642
                    ],
                    [
                        "items/3[]/variant_inventory_management",
                        "shopify"
                    ],
                    [
                        "items/3[]/variant_title",
                        null
                    ],
                    [
                        "items/3[]/vendor",
                        "BestPerfume.Store"
                    ],
                    [
                        "items/3[]/tax_lines",
                        []
                    ],
                    [
                        "items/3[]/tax_lines/0[]",
                        {}
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price",
                        "7.04"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/rate",
                        0.09
                    ],
                    [
                        "items/3[]/tax_lines/0[]/title",
                        "GST"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set",
                        {}
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/shop_money/amount",
                        "7.04"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/presentment_money/amount",
                        "7.04"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/channel_liable",
                        false
                    ],
                    [
                        "items/3[]/duties",
                        []
                    ],
                    [
                        "items/3[]/discount_allocations",
                        []
                    ],
                    [
                        "items/3[]/discount_allocations/0[]",
                        {}
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount",
                        "3.75"
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set",
                        {}
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/shop_money",
                        {}
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/shop_money/amount",
                        "3.75"
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/presentment_money/amount",
                        "3.75"
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/discount_application_index",
                        0
                    ],
                    [
                        "items/3[]/image",
                        {}
                    ],
                    [
                        "items/3[]/image/id",
                        42032900604226
                    ],
                    [
                        "items/3[]/image/position",
                        1
                    ],
                    [
                        "items/3[]/image/product_id",
                        8465411506498
                    ],
                    [
                        "items/3[]/image/width",
                        1300
                    ],
                    [
                        "items/3[]/image/height",
                        1300
                    ],
                    [
                        "items/3[]/image/alt",
                        null
                    ],
                    [
                        "items/3[]/image/src",
                        "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x30.png?v=1689729136"
                    ],
                    [
                        "items/3[]/image/created_at",
                        "2023-07-19T09:12:16+08:00"
                    ],
                    [
                        "items/3[]/image/updated_at",
                        "2023-07-19T09:12:16+08:00"
                    ],
                    [
                        "items/3[]/image/admin_graphql_api_id",
                        "gid://shopify/ProductImage/42032900604226"
                    ],
                    [
                        "items/3[]/image/variant_ids",
                        []
                    ],
                    [
                        "items/3[]/quantity",
                        1
                    ],
                    [
                        "items/3[]/picked_quantity",
                        0
                    ],
                    [
                        "items/3[]/delivered_quantity",
                        0
                    ],
                    [
                        "items/3[]/return_quantity",
                        0
                    ],
                    [
                        "items/3[]/lmd_fulfillable_quantity",
                        0
                    ],
                    [
                        "items/3[]/lmd_fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/3[]/item_status",
                        "ACTIVE"
                    ],
                    [
                        "items/3[]/picked_up",
                        false
                    ],
                    [
                        "items/3[]/_id",
                        "66d3f0fc7635a88cc3d35f8f"
                    ],
                    [
                        "items/3[]/history",
                        []
                    ],
                    [
                        "items/4[]",
                        {}
                    ],
                    [
                        "items/4[]/id",
                        15208925724994
                    ],
                    [
                        "items/4[]/admin_graphql_api_id",
                        "gid://shopify/LineItem/15208925724994"
                    ],
                    [
                        "items/4[]/attributed_staffs",
                        []
                    ],
                    [
                        "items/4[]/fulfillable_quantity",
                        1
                    ],
                    [
                        "items/4[]/fulfillment_service",
                        "manual"
                    ],
                    [
                        "items/4[]/fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/4[]/gift_card",
                        false
                    ],
                    [
                        "items/4[]/grams",
                        250
                    ],
                    [
                        "items/4[]/name",
                        "X01 - Adjusted for Heat (X01)"
                    ],
                    [
                        "items/4[]/price",
                        "89.00"
                    ],
                    [
                        "items/4[]/price_set",
                        {}
                    ],
                    [
                        "items/4[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/4[]/price_set/shop_money/amount",
                        "89.00"
                    ],
                    [
                        "items/4[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/4[]/price_set/presentment_money/amount",
                        "89.00"
                    ],
                    [
                        "items/4[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/product_exists",
                        true
                    ],
                    [
                        "items/4[]/product_id",
                        8465414357314
                    ],
                    [
                        "items/4[]/product_type",
                        "Perfume"
                    ],
                    [
                        "items/4[]/properties",
                        []
                    ],
                    [
                        "items/4[]/properties/0[]",
                        {}
                    ],
                    [
                        "items/4[]/properties/0[]/name",
                        "THIS IS A GIFT"
                    ],
                    [
                        "items/4[]/properties/0[]/value",
                        "No"
                    ],
                    [
                        "items/4[]/requires_shipping",
                        true
                    ],
                    [
                        "items/4[]/sku",
                        "TLC01"
                    ],
                    [
                        "items/4[]/taxable",
                        true
                    ],
                    [
                        "items/4[]/title",
                        "X01"
                    ],
                    [
                        "items/4[]/total_discount",
                        "0.00"
                    ],
                    [
                        "items/4[]/total_discount_set",
                        {}
                    ],
                    [
                        "items/4[]/total_discount_set/shop_money",
                        {}
                    ],
                    [
                        "items/4[]/total_discount_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/4[]/total_discount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/total_discount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/4[]/total_discount_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/4[]/total_discount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/variant_id",
                        46421151056194
                    ],
                    [
                        "items/4[]/variant_inventory_management",
                        "shopify"
                    ],
                    [
                        "items/4[]/variant_title",
                        "Adjusted for Heat (X01)"
                    ],
                    [
                        "items/4[]/vendor",
                        "BestPerfume.Store"
                    ],
                    [
                        "items/4[]/tax_lines",
                        []
                    ],
                    [
                        "items/4[]/tax_lines/0[]",
                        {}
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price",
                        "7.04"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/rate",
                        0.09
                    ],
                    [
                        "items/4[]/tax_lines/0[]/title",
                        "GST"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set",
                        {}
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/shop_money/amount",
                        "7.04"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/presentment_money/amount",
                        "7.04"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/channel_liable",
                        false
                    ],
                    [
                        "items/4[]/duties",
                        []
                    ],
                    [
                        "items/4[]/discount_allocations",
                        []
                    ],
                    [
                        "items/4[]/discount_allocations/0[]",
                        {}
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount",
                        "3.75"
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set",
                        {}
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/shop_money",
                        {}
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/shop_money/amount",
                        "3.75"
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/presentment_money/amount",
                        "3.75"
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/discount_application_index",
                        0
                    ],
                    [
                        "items/4[]/image",
                        {}
                    ],
                    [
                        "items/4[]/image/id",
                        42032825467202
                    ],
                    [
                        "items/4[]/image/position",
                        1
                    ],
                    [
                        "items/4[]/image/product_id",
                        8465414357314
                    ],
                    [
                        "items/4[]/image/width",
                        1300
                    ],
                    [
                        "items/4[]/image/height",
                        1300
                    ],
                    [
                        "items/4[]/image/alt",
                        null
                    ],
                    [
                        "items/4[]/image/src",
                        "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x01.png?v=1692971586"
                    ],
                    [
                        "items/4[]/image/created_at",
                        "2023-07-19T09:01:38+08:00"
                    ],
                    [
                        "items/4[]/image/updated_at",
                        "2023-08-25T21:53:06+08:00"
                    ],
                    [
                        "items/4[]/image/admin_graphql_api_id",
                        "gid://shopify/ProductImage/42032825467202"
                    ],
                    [
                        "items/4[]/image/variant_ids",
                        []
                    ],
                    [
                        "items/4[]/quantity",
                        1
                    ],
                    [
                        "items/4[]/picked_quantity",
                        0
                    ],
                    [
                        "items/4[]/delivered_quantity",
                        0
                    ],
                    [
                        "items/4[]/return_quantity",
                        0
                    ],
                    [
                        "items/4[]/lmd_fulfillable_quantity",
                        0
                    ],
                    [
                        "items/4[]/lmd_fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/4[]/item_status",
                        "ACTIVE"
                    ],
                    [
                        "items/4[]/picked_up",
                        false
                    ],
                    [
                        "items/4[]/_id",
                        "66d3f0fc7635a88cc3d35f91"
                    ],
                    [
                        "items/4[]/history",
                        []
                    ],
                    [
                        "managed_by",
                        "SCROLL_ENGINE"
                    ],
                    [
                        "order_placed_date",
                        "2024-09-01T04:43:34.000Z"
                    ],
                    [
                        "shipment_assigned",
                        false
                    ],
                    [
                        "shipment_status",
                        "NEW"
                    ],
                    [
                        "suggested_shipment_location",
                        []
                    ],
                    [
                        "transfer_type",
                        "LAST_MILE"
                    ],
                    [
                        "updatedAt",
                        "2024-09-01T04:43:40.552Z"
                    ]
                ],
                "removed": [],
                "edited": []
            },
            "restore_metadata": [
                {
                    "type": "add",
                    "key": "start_location",
                    "value": {
                        "shipment_location": "647f51a1f8469eddb58acbe5"
                    }
                },
                {
                    "type": "add",
                    "key": "end_location",
                    "value": {
                        "order_location": {
                            "title": "Customer's default",
                            "latLng": "1.429532,103.7974626",
                            "lat": "1.429532",
                            "lng": "103.7974626"
                        }
                    }
                },
                {
                    "type": "add",
                    "key": "delivery_timeslot",
                    "value": {
                        "title": "",
                        "date": null,
                        "start": 0,
                        "end": 1440
                    }
                },
                {
                    "type": "add",
                    "key": "_id",
                    "value": "66d3f0fcd5945fb6637d9a4c"
                },
                {
                    "type": "add",
                    "key": "order",
                    "value": "66d3f0fc7635a88cc3d35f89"
                },
                {
                    "type": "add",
                    "key": "tenant_id",
                    "value": "647f5198df12d9c3626610e2"
                },
                {
                    "type": "add",
                    "key": "__v",
                    "value": 0
                },
                {
                    "type": "add",
                    "key": "action_needed",
                    "value": false
                },
                {
                    "type": "add",
                    "key": "awb_no",
                    "value": "O5WZAPUCB7"
                },
                {
                    "type": "add",
                    "key": "claimable",
                    "value": false
                },
                {
                    "type": "add",
                    "key": "createdAt",
                    "value": "2024-09-01T04:43:34.000Z"
                },
                {
                    "type": "add",
                    "key": "delivery_metadata",
                    "value": {
                        "delivery_date": null,
                        "pincode": "",
                        "location_id": "",
                        "location_title": "",
                        "slot_id": "",
                        "slot_title": ""
                    }
                },
                {
                    "type": "add",
                    "key": "delivery_method",
                    "value": "LOCAL_DELIVERY"
                },
                {
                    "type": "add",
                    "key": "isArcheived",
                    "value": false
                },
                {
                    "type": "add",
                    "key": "items",
                    "value": [
                        {
                            "id": 15208925593922,
                            "admin_graphql_api_id": "gid://shopify/LineItem/15208925593922",
                            "attributed_staffs": [],
                            "fulfillable_quantity": 1,
                            "fulfillment_service": "manual",
                            "fulfillment_status": "UNFULFILLED",
                            "gift_card": false,
                            "grams": 250,
                            "name": "X95",
                            "price": "89.00",
                            "price_set": {
                                "shop_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "product_exists": true,
                            "product_id": 8812656689474,
                            "product_type": "Perfume",
                            "properties": [
                                {
                                    "name": "THIS IS A GIFT",
                                    "value": "No"
                                }
                            ],
                            "requires_shipping": true,
                            "sku": "TLC95",
                            "taxable": true,
                            "title": "X95",
                            "total_discount": "0.00",
                            "total_discount_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "variant_id": 47034631258434,
                            "variant_inventory_management": "shopify",
                            "variant_title": null,
                            "vendor": "BestPerfume.Store",
                            "tax_lines": [
                                {
                                    "price": "7.04",
                                    "rate": 0.09,
                                    "title": "GST",
                                    "price_set": {
                                        "shop_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "channel_liable": false
                                }
                            ],
                            "duties": [],
                            "discount_allocations": [
                                {
                                    "amount": "3.75",
                                    "amount_set": {
                                        "shop_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "discount_application_index": 0
                                }
                            ],
                            "image": {
                                "id": 42902965911874,
                                "position": 1,
                                "product_id": 8812656689474,
                                "width": 1300,
                                "height": 1300,
                                "alt": null,
                                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x95.png?v=1696268914",
                                "created_at": "2023-10-03T01:48:34+08:00",
                                "updated_at": "2023-10-03T01:48:34+08:00",
                                "admin_graphql_api_id": "gid://shopify/ProductImage/42902965911874",
                                "variant_ids": []
                            },
                            "quantity": 1,
                            "picked_quantity": 0,
                            "delivered_quantity": 0,
                            "return_quantity": 0,
                            "lmd_fulfillable_quantity": 0,
                            "lmd_fulfillment_status": "UNFULFILLED",
                            "item_status": "ACTIVE",
                            "picked_up": false,
                            "_id": "66d3f0fc7635a88cc3d35f8a",
                            "history": []
                        },
                        {
                            "id": 15208925626690,
                            "admin_graphql_api_id": "gid://shopify/LineItem/15208925626690",
                            "attributed_staffs": [],
                            "fulfillable_quantity": 1,
                            "fulfillment_service": "manual",
                            "fulfillment_status": "UNFULFILLED",
                            "gift_card": false,
                            "grams": 0,
                            "name": "FREE Luxury Refillable Atomiser",
                            "price": "0.00",
                            "price_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "product_exists": true,
                            "product_id": 8476207874370,
                            "product_type": "Gift",
                            "properties": [],
                            "requires_shipping": true,
                            "sku": "AC01",
                            "taxable": true,
                            "title": "FREE Luxury Refillable Atomiser",
                            "total_discount": "0.00",
                            "total_discount_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "variant_id": 45731893936450,
                            "variant_inventory_management": "shopify",
                            "variant_title": null,
                            "vendor": "BestPerfume.Store",
                            "tax_lines": [
                                {
                                    "price": "0.00",
                                    "rate": 0.09,
                                    "title": "GST",
                                    "price_set": {
                                        "shop_money": {
                                            "amount": "0.00",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "0.00",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "channel_liable": false
                                }
                            ],
                            "duties": [],
                            "discount_allocations": [],
                            "image": {
                                "id": 43375725936962,
                                "position": 1,
                                "product_id": 8476207874370,
                                "width": 960,
                                "height": 1080,
                                "alt": null,
                                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/luxuryperfumeatomiser.png?v=1700300379",
                                "created_at": "2023-11-18T17:39:39+08:00",
                                "updated_at": "2023-11-18T17:39:39+08:00",
                                "admin_graphql_api_id": "gid://shopify/ProductImage/43375725936962",
                                "variant_ids": []
                            },
                            "quantity": 1,
                            "picked_quantity": 0,
                            "delivered_quantity": 0,
                            "return_quantity": 0,
                            "lmd_fulfillable_quantity": 0,
                            "lmd_fulfillment_status": "UNFULFILLED",
                            "item_status": "ACTIVE",
                            "picked_up": false,
                            "_id": "66d3f0fc7635a88cc3d35f8c",
                            "history": []
                        },
                        {
                            "id": 15208925659458,
                            "admin_graphql_api_id": "gid://shopify/LineItem/15208925659458",
                            "attributed_staffs": [],
                            "fulfillable_quantity": 1,
                            "fulfillment_service": "manual",
                            "fulfillment_status": "UNFULFILLED",
                            "gift_card": false,
                            "grams": 250,
                            "name": "X54",
                            "price": "89.00",
                            "price_set": {
                                "shop_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "product_exists": true,
                            "product_id": 8465409016130,
                            "product_type": "Perfume",
                            "properties": [
                                {
                                    "name": "THIS IS A GIFT",
                                    "value": "No"
                                }
                            ],
                            "requires_shipping": true,
                            "sku": "TLC54",
                            "taxable": true,
                            "title": "X54",
                            "total_discount": "0.00",
                            "total_discount_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "variant_id": 45670043615554,
                            "variant_inventory_management": "shopify",
                            "variant_title": null,
                            "vendor": "BestPerfume.Store",
                            "tax_lines": [
                                {
                                    "price": "7.04",
                                    "rate": 0.09,
                                    "title": "GST",
                                    "price_set": {
                                        "shop_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "channel_liable": false
                                }
                            ],
                            "duties": [],
                            "discount_allocations": [
                                {
                                    "amount": "3.75",
                                    "amount_set": {
                                        "shop_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "discount_application_index": 0
                                }
                            ],
                            "image": {
                                "id": 42032937959746,
                                "position": 1,
                                "product_id": 8465409016130,
                                "width": 1300,
                                "height": 1300,
                                "alt": null,
                                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x54.png?v=1689729448",
                                "created_at": "2023-07-19T09:17:28+08:00",
                                "updated_at": "2023-07-19T09:17:28+08:00",
                                "admin_graphql_api_id": "gid://shopify/ProductImage/42032937959746",
                                "variant_ids": []
                            },
                            "quantity": 1,
                            "picked_quantity": 0,
                            "delivered_quantity": 0,
                            "return_quantity": 0,
                            "lmd_fulfillable_quantity": 0,
                            "lmd_fulfillment_status": "UNFULFILLED",
                            "item_status": "ACTIVE",
                            "picked_up": false,
                            "_id": "66d3f0fc7635a88cc3d35f8d",
                            "history": []
                        },
                        {
                            "id": 15208925692226,
                            "admin_graphql_api_id": "gid://shopify/LineItem/15208925692226",
                            "attributed_staffs": [],
                            "fulfillable_quantity": 1,
                            "fulfillment_service": "manual",
                            "fulfillment_status": "UNFULFILLED",
                            "gift_card": false,
                            "grams": 250,
                            "name": "X30",
                            "price": "89.00",
                            "price_set": {
                                "shop_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "product_exists": true,
                            "product_id": 8465411506498,
                            "product_type": "Perfume",
                            "properties": [
                                {
                                    "name": "THIS IS A GIFT",
                                    "value": "No"
                                }
                            ],
                            "requires_shipping": true,
                            "sku": "TLC30",
                            "taxable": true,
                            "title": "X30",
                            "total_discount": "0.00",
                            "total_discount_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "variant_id": 45670051512642,
                            "variant_inventory_management": "shopify",
                            "variant_title": null,
                            "vendor": "BestPerfume.Store",
                            "tax_lines": [
                                {
                                    "price": "7.04",
                                    "rate": 0.09,
                                    "title": "GST",
                                    "price_set": {
                                        "shop_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "channel_liable": false
                                }
                            ],
                            "duties": [],
                            "discount_allocations": [
                                {
                                    "amount": "3.75",
                                    "amount_set": {
                                        "shop_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "discount_application_index": 0
                                }
                            ],
                            "image": {
                                "id": 42032900604226,
                                "position": 1,
                                "product_id": 8465411506498,
                                "width": 1300,
                                "height": 1300,
                                "alt": null,
                                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x30.png?v=1689729136",
                                "created_at": "2023-07-19T09:12:16+08:00",
                                "updated_at": "2023-07-19T09:12:16+08:00",
                                "admin_graphql_api_id": "gid://shopify/ProductImage/42032900604226",
                                "variant_ids": []
                            },
                            "quantity": 1,
                            "picked_quantity": 0,
                            "delivered_quantity": 0,
                            "return_quantity": 0,
                            "lmd_fulfillable_quantity": 0,
                            "lmd_fulfillment_status": "UNFULFILLED",
                            "item_status": "ACTIVE",
                            "picked_up": false,
                            "_id": "66d3f0fc7635a88cc3d35f8f",
                            "history": []
                        },
                        {
                            "id": 15208925724994,
                            "admin_graphql_api_id": "gid://shopify/LineItem/15208925724994",
                            "attributed_staffs": [],
                            "fulfillable_quantity": 1,
                            "fulfillment_service": "manual",
                            "fulfillment_status": "UNFULFILLED",
                            "gift_card": false,
                            "grams": 250,
                            "name": "X01 - Adjusted for Heat (X01)",
                            "price": "89.00",
                            "price_set": {
                                "shop_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "product_exists": true,
                            "product_id": 8465414357314,
                            "product_type": "Perfume",
                            "properties": [
                                {
                                    "name": "THIS IS A GIFT",
                                    "value": "No"
                                }
                            ],
                            "requires_shipping": true,
                            "sku": "TLC01",
                            "taxable": true,
                            "title": "X01",
                            "total_discount": "0.00",
                            "total_discount_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "variant_id": 46421151056194,
                            "variant_inventory_management": "shopify",
                            "variant_title": "Adjusted for Heat (X01)",
                            "vendor": "BestPerfume.Store",
                            "tax_lines": [
                                {
                                    "price": "7.04",
                                    "rate": 0.09,
                                    "title": "GST",
                                    "price_set": {
                                        "shop_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "channel_liable": false
                                }
                            ],
                            "duties": [],
                            "discount_allocations": [
                                {
                                    "amount": "3.75",
                                    "amount_set": {
                                        "shop_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "discount_application_index": 0
                                }
                            ],
                            "image": {
                                "id": 42032825467202,
                                "position": 1,
                                "product_id": 8465414357314,
                                "width": 1300,
                                "height": 1300,
                                "alt": null,
                                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x01.png?v=1692971586",
                                "created_at": "2023-07-19T09:01:38+08:00",
                                "updated_at": "2023-08-25T21:53:06+08:00",
                                "admin_graphql_api_id": "gid://shopify/ProductImage/42032825467202",
                                "variant_ids": []
                            },
                            "quantity": 1,
                            "picked_quantity": 0,
                            "delivered_quantity": 0,
                            "return_quantity": 0,
                            "lmd_fulfillable_quantity": 0,
                            "lmd_fulfillment_status": "UNFULFILLED",
                            "item_status": "ACTIVE",
                            "picked_up": false,
                            "_id": "66d3f0fc7635a88cc3d35f91",
                            "history": []
                        }
                    ]
                },
                {
                    "type": "add",
                    "key": "managed_by",
                    "value": "SCROLL_ENGINE"
                },
                {
                    "type": "add",
                    "key": "order_placed_date",
                    "value": "2024-09-01T04:43:34.000Z"
                },
                {
                    "type": "add",
                    "key": "shipment_assigned",
                    "value": false
                },
                {
                    "type": "add",
                    "key": "shipment_status",
                    "value": "NEW"
                },
                {
                    "type": "add",
                    "key": "suggested_shipment_location",
                    "value": []
                },
                {
                    "type": "add",
                    "key": "transfer_type",
                    "value": "LAST_MILE"
                },
                {
                    "type": "add",
                    "key": "updatedAt",
                    "value": "2024-09-01T04:43:40.552Z"
                }
            ],
            "updated_at": "2024-09-01T04:43:40.688Z",
            "isArcheived": false,
            "tenant_id": "647f5198df12d9c3626610e2",
            "createdAt": "2024-09-01T04:43:40.691Z",
            "updatedAt": "2024-09-01T04:43:40.691Z",
            "__v": 0
        }
    ],
    "shipment_item_history": [
        {
            "_id": "66d43ff7f7486410fc7dbf39",
            "user_id": "6543800530981bd50ab6b610",
            "shipment_id": "66d3f0fcd5945fb6637d9a4c",
            "action_type": "SHIPMENT",
            "updated_status": "OUT_FOR_DELIVERY",
            "previous_status": "OUT_FOR_DELIVERY",
            "notes": "SHIPMENT -> UPDATED",
            "custom_notes": "",
            "reschedule_date": "",
            "diff_metadata": {
                "added": [],
                "removed": [],
                "edited": []
            },
            "restore_metadata": [],
            "updated_at": "2024-09-01T10:20:39.133Z",
            "isArcheived": false,
            "tenant_id": "647f5198df12d9c3626610e2",
            "createdAt": "2024-09-01T10:20:39.134Z",
            "updatedAt": "2024-09-01T10:20:39.134Z",
            "__v": 0
        },
        {
            "_id": "66d3fe629af51ccfdf43610a",
            "user_id": "6543800530981bd50ab6b610",
            "shipment_id": "66d3f0fcd5945fb6637d9a4c",
            "action_type": "SHIPMENT",
            "updated_status": "PICKED_UP",
            "previous_status": "PICKED_UP",
            "notes": "SHIPMENT -> PICKED UP",
            "custom_notes": "",
            "reschedule_date": "",
            "diff_metadata": {
                "added": [],
                "removed": [],
                "edited": []
            },
            "restore_metadata": [],
            "updated_at": "2024-09-01T05:40:50.107Z",
            "isArcheived": false,
            "tenant_id": "647f5198df12d9c3626610e2",
            "createdAt": "2024-09-01T05:40:50.108Z",
            "updatedAt": "2024-09-01T05:40:50.108Z",
            "__v": 0
        },
        {
            "_id": "66d3f0fc7635a88cc3d35fa2",
            "shipment_id": "66d3f0fcd5945fb6637d9a4c",
            "action_type": "SHIPMENT",
            "updated_status": "NEW",
            "previous_status": "",
            "notes": "SHIPMENT -> CREATED",
            "custom_notes": "",
            "reschedule_date": "",
            "diff_metadata": {
                "added": [
                    [
                        "start_location",
                        {}
                    ],
                    [
                        "start_location/shipment_location",
                        "647f51a1f8469eddb58acbe5"
                    ],
                    [
                        "end_location",
                        {}
                    ],
                    [
                        "end_location/order_location",
                        {}
                    ],
                    [
                        "end_location/order_location/title",
                        "Customer's default"
                    ],
                    [
                        "end_location/order_location/latLng",
                        "1.429532,103.7974626"
                    ],
                    [
                        "end_location/order_location/lat",
                        "1.429532"
                    ],
                    [
                        "end_location/order_location/lng",
                        "103.7974626"
                    ],
                    [
                        "delivery_timeslot",
                        {}
                    ],
                    [
                        "delivery_timeslot/title",
                        ""
                    ],
                    [
                        "delivery_timeslot/date",
                        null
                    ],
                    [
                        "delivery_timeslot/start",
                        0
                    ],
                    [
                        "delivery_timeslot/end",
                        1440
                    ],
                    [
                        "_id",
                        "66d3f0fcd5945fb6637d9a4c"
                    ],
                    [
                        "order",
                        "66d3f0fc7635a88cc3d35f89"
                    ],
                    [
                        "tenant_id",
                        "647f5198df12d9c3626610e2"
                    ],
                    [
                        "__v",
                        0
                    ],
                    [
                        "action_needed",
                        false
                    ],
                    [
                        "awb_no",
                        "O5WZAPUCB7"
                    ],
                    [
                        "claimable",
                        false
                    ],
                    [
                        "createdAt",
                        "2024-09-01T04:43:34.000Z"
                    ],
                    [
                        "delivery_metadata",
                        {}
                    ],
                    [
                        "delivery_metadata/delivery_date",
                        null
                    ],
                    [
                        "delivery_metadata/pincode",
                        ""
                    ],
                    [
                        "delivery_metadata/location_id",
                        ""
                    ],
                    [
                        "delivery_metadata/location_title",
                        ""
                    ],
                    [
                        "delivery_metadata/slot_id",
                        ""
                    ],
                    [
                        "delivery_metadata/slot_title",
                        ""
                    ],
                    [
                        "delivery_method",
                        "LOCAL_DELIVERY"
                    ],
                    [
                        "isArcheived",
                        false
                    ],
                    [
                        "items",
                        []
                    ],
                    [
                        "items/0[]",
                        {}
                    ],
                    [
                        "items/0[]/id",
                        15208925593922
                    ],
                    [
                        "items/0[]/admin_graphql_api_id",
                        "gid://shopify/LineItem/15208925593922"
                    ],
                    [
                        "items/0[]/attributed_staffs",
                        []
                    ],
                    [
                        "items/0[]/fulfillable_quantity",
                        1
                    ],
                    [
                        "items/0[]/fulfillment_service",
                        "manual"
                    ],
                    [
                        "items/0[]/fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/0[]/gift_card",
                        false
                    ],
                    [
                        "items/0[]/grams",
                        250
                    ],
                    [
                        "items/0[]/name",
                        "X95"
                    ],
                    [
                        "items/0[]/price",
                        "89.00"
                    ],
                    [
                        "items/0[]/price_set",
                        {}
                    ],
                    [
                        "items/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/0[]/price_set/shop_money/amount",
                        "89.00"
                    ],
                    [
                        "items/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/0[]/price_set/presentment_money/amount",
                        "89.00"
                    ],
                    [
                        "items/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/product_exists",
                        true
                    ],
                    [
                        "items/0[]/product_id",
                        8812656689474
                    ],
                    [
                        "items/0[]/product_type",
                        "Perfume"
                    ],
                    [
                        "items/0[]/properties",
                        []
                    ],
                    [
                        "items/0[]/properties/0[]",
                        {}
                    ],
                    [
                        "items/0[]/properties/0[]/name",
                        "THIS IS A GIFT"
                    ],
                    [
                        "items/0[]/properties/0[]/value",
                        "No"
                    ],
                    [
                        "items/0[]/requires_shipping",
                        true
                    ],
                    [
                        "items/0[]/sku",
                        "TLC95"
                    ],
                    [
                        "items/0[]/taxable",
                        true
                    ],
                    [
                        "items/0[]/title",
                        "X95"
                    ],
                    [
                        "items/0[]/total_discount",
                        "0.00"
                    ],
                    [
                        "items/0[]/total_discount_set",
                        {}
                    ],
                    [
                        "items/0[]/total_discount_set/shop_money",
                        {}
                    ],
                    [
                        "items/0[]/total_discount_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/0[]/total_discount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/total_discount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/0[]/total_discount_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/0[]/total_discount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/variant_id",
                        47034631258434
                    ],
                    [
                        "items/0[]/variant_inventory_management",
                        "shopify"
                    ],
                    [
                        "items/0[]/variant_title",
                        null
                    ],
                    [
                        "items/0[]/vendor",
                        "BestPerfume.Store"
                    ],
                    [
                        "items/0[]/tax_lines",
                        []
                    ],
                    [
                        "items/0[]/tax_lines/0[]",
                        {}
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price",
                        "7.04"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/rate",
                        0.09
                    ],
                    [
                        "items/0[]/tax_lines/0[]/title",
                        "GST"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set",
                        {}
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/shop_money/amount",
                        "7.04"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/presentment_money/amount",
                        "7.04"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/tax_lines/0[]/channel_liable",
                        false
                    ],
                    [
                        "items/0[]/duties",
                        []
                    ],
                    [
                        "items/0[]/discount_allocations",
                        []
                    ],
                    [
                        "items/0[]/discount_allocations/0[]",
                        {}
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount",
                        "3.75"
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set",
                        {}
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/shop_money",
                        {}
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/shop_money/amount",
                        "3.75"
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/presentment_money/amount",
                        "3.75"
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/amount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/0[]/discount_allocations/0[]/discount_application_index",
                        0
                    ],
                    [
                        "items/0[]/image",
                        {}
                    ],
                    [
                        "items/0[]/image/id",
                        42902965911874
                    ],
                    [
                        "items/0[]/image/position",
                        1
                    ],
                    [
                        "items/0[]/image/product_id",
                        8812656689474
                    ],
                    [
                        "items/0[]/image/width",
                        1300
                    ],
                    [
                        "items/0[]/image/height",
                        1300
                    ],
                    [
                        "items/0[]/image/alt",
                        null
                    ],
                    [
                        "items/0[]/image/src",
                        "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x95.png?v=1696268914"
                    ],
                    [
                        "items/0[]/image/created_at",
                        "2023-10-03T01:48:34+08:00"
                    ],
                    [
                        "items/0[]/image/updated_at",
                        "2023-10-03T01:48:34+08:00"
                    ],
                    [
                        "items/0[]/image/admin_graphql_api_id",
                        "gid://shopify/ProductImage/42902965911874"
                    ],
                    [
                        "items/0[]/image/variant_ids",
                        []
                    ],
                    [
                        "items/0[]/quantity",
                        1
                    ],
                    [
                        "items/0[]/picked_quantity",
                        0
                    ],
                    [
                        "items/0[]/delivered_quantity",
                        0
                    ],
                    [
                        "items/0[]/return_quantity",
                        0
                    ],
                    [
                        "items/0[]/lmd_fulfillable_quantity",
                        0
                    ],
                    [
                        "items/0[]/lmd_fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/0[]/item_status",
                        "ACTIVE"
                    ],
                    [
                        "items/0[]/picked_up",
                        false
                    ],
                    [
                        "items/0[]/_id",
                        "66d3f0fc7635a88cc3d35f8a"
                    ],
                    [
                        "items/0[]/history",
                        []
                    ],
                    [
                        "items/1[]",
                        {}
                    ],
                    [
                        "items/1[]/id",
                        15208925626690
                    ],
                    [
                        "items/1[]/admin_graphql_api_id",
                        "gid://shopify/LineItem/15208925626690"
                    ],
                    [
                        "items/1[]/attributed_staffs",
                        []
                    ],
                    [
                        "items/1[]/fulfillable_quantity",
                        1
                    ],
                    [
                        "items/1[]/fulfillment_service",
                        "manual"
                    ],
                    [
                        "items/1[]/fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/1[]/gift_card",
                        false
                    ],
                    [
                        "items/1[]/grams",
                        0
                    ],
                    [
                        "items/1[]/name",
                        "FREE Luxury Refillable Atomiser"
                    ],
                    [
                        "items/1[]/price",
                        "0.00"
                    ],
                    [
                        "items/1[]/price_set",
                        {}
                    ],
                    [
                        "items/1[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/1[]/price_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/1[]/price_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/product_exists",
                        true
                    ],
                    [
                        "items/1[]/product_id",
                        8476207874370
                    ],
                    [
                        "items/1[]/product_type",
                        "Gift"
                    ],
                    [
                        "items/1[]/properties",
                        []
                    ],
                    [
                        "items/1[]/requires_shipping",
                        true
                    ],
                    [
                        "items/1[]/sku",
                        "AC01"
                    ],
                    [
                        "items/1[]/taxable",
                        true
                    ],
                    [
                        "items/1[]/title",
                        "FREE Luxury Refillable Atomiser"
                    ],
                    [
                        "items/1[]/total_discount",
                        "0.00"
                    ],
                    [
                        "items/1[]/total_discount_set",
                        {}
                    ],
                    [
                        "items/1[]/total_discount_set/shop_money",
                        {}
                    ],
                    [
                        "items/1[]/total_discount_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/total_discount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/total_discount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/1[]/total_discount_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/total_discount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/variant_id",
                        45731893936450
                    ],
                    [
                        "items/1[]/variant_inventory_management",
                        "shopify"
                    ],
                    [
                        "items/1[]/variant_title",
                        null
                    ],
                    [
                        "items/1[]/vendor",
                        "BestPerfume.Store"
                    ],
                    [
                        "items/1[]/tax_lines",
                        []
                    ],
                    [
                        "items/1[]/tax_lines/0[]",
                        {}
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price",
                        "0.00"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/rate",
                        0.09
                    ],
                    [
                        "items/1[]/tax_lines/0[]/title",
                        "GST"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set",
                        {}
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/1[]/tax_lines/0[]/channel_liable",
                        false
                    ],
                    [
                        "items/1[]/duties",
                        []
                    ],
                    [
                        "items/1[]/discount_allocations",
                        []
                    ],
                    [
                        "items/1[]/image",
                        {}
                    ],
                    [
                        "items/1[]/image/id",
                        43375725936962
                    ],
                    [
                        "items/1[]/image/position",
                        1
                    ],
                    [
                        "items/1[]/image/product_id",
                        8476207874370
                    ],
                    [
                        "items/1[]/image/width",
                        960
                    ],
                    [
                        "items/1[]/image/height",
                        1080
                    ],
                    [
                        "items/1[]/image/alt",
                        null
                    ],
                    [
                        "items/1[]/image/src",
                        "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/luxuryperfumeatomiser.png?v=1700300379"
                    ],
                    [
                        "items/1[]/image/created_at",
                        "2023-11-18T17:39:39+08:00"
                    ],
                    [
                        "items/1[]/image/updated_at",
                        "2023-11-18T17:39:39+08:00"
                    ],
                    [
                        "items/1[]/image/admin_graphql_api_id",
                        "gid://shopify/ProductImage/43375725936962"
                    ],
                    [
                        "items/1[]/image/variant_ids",
                        []
                    ],
                    [
                        "items/1[]/quantity",
                        1
                    ],
                    [
                        "items/1[]/picked_quantity",
                        0
                    ],
                    [
                        "items/1[]/delivered_quantity",
                        0
                    ],
                    [
                        "items/1[]/return_quantity",
                        0
                    ],
                    [
                        "items/1[]/lmd_fulfillable_quantity",
                        0
                    ],
                    [
                        "items/1[]/lmd_fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/1[]/item_status",
                        "ACTIVE"
                    ],
                    [
                        "items/1[]/picked_up",
                        false
                    ],
                    [
                        "items/1[]/_id",
                        "66d3f0fc7635a88cc3d35f8c"
                    ],
                    [
                        "items/1[]/history",
                        []
                    ],
                    [
                        "items/2[]",
                        {}
                    ],
                    [
                        "items/2[]/id",
                        15208925659458
                    ],
                    [
                        "items/2[]/admin_graphql_api_id",
                        "gid://shopify/LineItem/15208925659458"
                    ],
                    [
                        "items/2[]/attributed_staffs",
                        []
                    ],
                    [
                        "items/2[]/fulfillable_quantity",
                        1
                    ],
                    [
                        "items/2[]/fulfillment_service",
                        "manual"
                    ],
                    [
                        "items/2[]/fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/2[]/gift_card",
                        false
                    ],
                    [
                        "items/2[]/grams",
                        250
                    ],
                    [
                        "items/2[]/name",
                        "X54"
                    ],
                    [
                        "items/2[]/price",
                        "89.00"
                    ],
                    [
                        "items/2[]/price_set",
                        {}
                    ],
                    [
                        "items/2[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/2[]/price_set/shop_money/amount",
                        "89.00"
                    ],
                    [
                        "items/2[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/2[]/price_set/presentment_money/amount",
                        "89.00"
                    ],
                    [
                        "items/2[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/product_exists",
                        true
                    ],
                    [
                        "items/2[]/product_id",
                        8465409016130
                    ],
                    [
                        "items/2[]/product_type",
                        "Perfume"
                    ],
                    [
                        "items/2[]/properties",
                        []
                    ],
                    [
                        "items/2[]/properties/0[]",
                        {}
                    ],
                    [
                        "items/2[]/properties/0[]/name",
                        "THIS IS A GIFT"
                    ],
                    [
                        "items/2[]/properties/0[]/value",
                        "No"
                    ],
                    [
                        "items/2[]/requires_shipping",
                        true
                    ],
                    [
                        "items/2[]/sku",
                        "TLC54"
                    ],
                    [
                        "items/2[]/taxable",
                        true
                    ],
                    [
                        "items/2[]/title",
                        "X54"
                    ],
                    [
                        "items/2[]/total_discount",
                        "0.00"
                    ],
                    [
                        "items/2[]/total_discount_set",
                        {}
                    ],
                    [
                        "items/2[]/total_discount_set/shop_money",
                        {}
                    ],
                    [
                        "items/2[]/total_discount_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/2[]/total_discount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/total_discount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/2[]/total_discount_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/2[]/total_discount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/variant_id",
                        45670043615554
                    ],
                    [
                        "items/2[]/variant_inventory_management",
                        "shopify"
                    ],
                    [
                        "items/2[]/variant_title",
                        null
                    ],
                    [
                        "items/2[]/vendor",
                        "BestPerfume.Store"
                    ],
                    [
                        "items/2[]/tax_lines",
                        []
                    ],
                    [
                        "items/2[]/tax_lines/0[]",
                        {}
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price",
                        "7.04"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/rate",
                        0.09
                    ],
                    [
                        "items/2[]/tax_lines/0[]/title",
                        "GST"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set",
                        {}
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/shop_money/amount",
                        "7.04"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/presentment_money/amount",
                        "7.04"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/tax_lines/0[]/channel_liable",
                        false
                    ],
                    [
                        "items/2[]/duties",
                        []
                    ],
                    [
                        "items/2[]/discount_allocations",
                        []
                    ],
                    [
                        "items/2[]/discount_allocations/0[]",
                        {}
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount",
                        "3.75"
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set",
                        {}
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/shop_money",
                        {}
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/shop_money/amount",
                        "3.75"
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/presentment_money/amount",
                        "3.75"
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/amount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/2[]/discount_allocations/0[]/discount_application_index",
                        0
                    ],
                    [
                        "items/2[]/image",
                        {}
                    ],
                    [
                        "items/2[]/image/id",
                        42032937959746
                    ],
                    [
                        "items/2[]/image/position",
                        1
                    ],
                    [
                        "items/2[]/image/product_id",
                        8465409016130
                    ],
                    [
                        "items/2[]/image/width",
                        1300
                    ],
                    [
                        "items/2[]/image/height",
                        1300
                    ],
                    [
                        "items/2[]/image/alt",
                        null
                    ],
                    [
                        "items/2[]/image/src",
                        "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x54.png?v=1689729448"
                    ],
                    [
                        "items/2[]/image/created_at",
                        "2023-07-19T09:17:28+08:00"
                    ],
                    [
                        "items/2[]/image/updated_at",
                        "2023-07-19T09:17:28+08:00"
                    ],
                    [
                        "items/2[]/image/admin_graphql_api_id",
                        "gid://shopify/ProductImage/42032937959746"
                    ],
                    [
                        "items/2[]/image/variant_ids",
                        []
                    ],
                    [
                        "items/2[]/quantity",
                        1
                    ],
                    [
                        "items/2[]/picked_quantity",
                        0
                    ],
                    [
                        "items/2[]/delivered_quantity",
                        0
                    ],
                    [
                        "items/2[]/return_quantity",
                        0
                    ],
                    [
                        "items/2[]/lmd_fulfillable_quantity",
                        0
                    ],
                    [
                        "items/2[]/lmd_fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/2[]/item_status",
                        "ACTIVE"
                    ],
                    [
                        "items/2[]/picked_up",
                        false
                    ],
                    [
                        "items/2[]/_id",
                        "66d3f0fc7635a88cc3d35f8d"
                    ],
                    [
                        "items/2[]/history",
                        []
                    ],
                    [
                        "items/3[]",
                        {}
                    ],
                    [
                        "items/3[]/id",
                        15208925692226
                    ],
                    [
                        "items/3[]/admin_graphql_api_id",
                        "gid://shopify/LineItem/15208925692226"
                    ],
                    [
                        "items/3[]/attributed_staffs",
                        []
                    ],
                    [
                        "items/3[]/fulfillable_quantity",
                        1
                    ],
                    [
                        "items/3[]/fulfillment_service",
                        "manual"
                    ],
                    [
                        "items/3[]/fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/3[]/gift_card",
                        false
                    ],
                    [
                        "items/3[]/grams",
                        250
                    ],
                    [
                        "items/3[]/name",
                        "X30"
                    ],
                    [
                        "items/3[]/price",
                        "89.00"
                    ],
                    [
                        "items/3[]/price_set",
                        {}
                    ],
                    [
                        "items/3[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/3[]/price_set/shop_money/amount",
                        "89.00"
                    ],
                    [
                        "items/3[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/3[]/price_set/presentment_money/amount",
                        "89.00"
                    ],
                    [
                        "items/3[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/product_exists",
                        true
                    ],
                    [
                        "items/3[]/product_id",
                        8465411506498
                    ],
                    [
                        "items/3[]/product_type",
                        "Perfume"
                    ],
                    [
                        "items/3[]/properties",
                        []
                    ],
                    [
                        "items/3[]/properties/0[]",
                        {}
                    ],
                    [
                        "items/3[]/properties/0[]/name",
                        "THIS IS A GIFT"
                    ],
                    [
                        "items/3[]/properties/0[]/value",
                        "No"
                    ],
                    [
                        "items/3[]/requires_shipping",
                        true
                    ],
                    [
                        "items/3[]/sku",
                        "TLC30"
                    ],
                    [
                        "items/3[]/taxable",
                        true
                    ],
                    [
                        "items/3[]/title",
                        "X30"
                    ],
                    [
                        "items/3[]/total_discount",
                        "0.00"
                    ],
                    [
                        "items/3[]/total_discount_set",
                        {}
                    ],
                    [
                        "items/3[]/total_discount_set/shop_money",
                        {}
                    ],
                    [
                        "items/3[]/total_discount_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/3[]/total_discount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/total_discount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/3[]/total_discount_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/3[]/total_discount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/variant_id",
                        45670051512642
                    ],
                    [
                        "items/3[]/variant_inventory_management",
                        "shopify"
                    ],
                    [
                        "items/3[]/variant_title",
                        null
                    ],
                    [
                        "items/3[]/vendor",
                        "BestPerfume.Store"
                    ],
                    [
                        "items/3[]/tax_lines",
                        []
                    ],
                    [
                        "items/3[]/tax_lines/0[]",
                        {}
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price",
                        "7.04"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/rate",
                        0.09
                    ],
                    [
                        "items/3[]/tax_lines/0[]/title",
                        "GST"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set",
                        {}
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/shop_money/amount",
                        "7.04"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/presentment_money/amount",
                        "7.04"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/tax_lines/0[]/channel_liable",
                        false
                    ],
                    [
                        "items/3[]/duties",
                        []
                    ],
                    [
                        "items/3[]/discount_allocations",
                        []
                    ],
                    [
                        "items/3[]/discount_allocations/0[]",
                        {}
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount",
                        "3.75"
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set",
                        {}
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/shop_money",
                        {}
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/shop_money/amount",
                        "3.75"
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/presentment_money/amount",
                        "3.75"
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/amount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/3[]/discount_allocations/0[]/discount_application_index",
                        0
                    ],
                    [
                        "items/3[]/image",
                        {}
                    ],
                    [
                        "items/3[]/image/id",
                        42032900604226
                    ],
                    [
                        "items/3[]/image/position",
                        1
                    ],
                    [
                        "items/3[]/image/product_id",
                        8465411506498
                    ],
                    [
                        "items/3[]/image/width",
                        1300
                    ],
                    [
                        "items/3[]/image/height",
                        1300
                    ],
                    [
                        "items/3[]/image/alt",
                        null
                    ],
                    [
                        "items/3[]/image/src",
                        "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x30.png?v=1689729136"
                    ],
                    [
                        "items/3[]/image/created_at",
                        "2023-07-19T09:12:16+08:00"
                    ],
                    [
                        "items/3[]/image/updated_at",
                        "2023-07-19T09:12:16+08:00"
                    ],
                    [
                        "items/3[]/image/admin_graphql_api_id",
                        "gid://shopify/ProductImage/42032900604226"
                    ],
                    [
                        "items/3[]/image/variant_ids",
                        []
                    ],
                    [
                        "items/3[]/quantity",
                        1
                    ],
                    [
                        "items/3[]/picked_quantity",
                        0
                    ],
                    [
                        "items/3[]/delivered_quantity",
                        0
                    ],
                    [
                        "items/3[]/return_quantity",
                        0
                    ],
                    [
                        "items/3[]/lmd_fulfillable_quantity",
                        0
                    ],
                    [
                        "items/3[]/lmd_fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/3[]/item_status",
                        "ACTIVE"
                    ],
                    [
                        "items/3[]/picked_up",
                        false
                    ],
                    [
                        "items/3[]/_id",
                        "66d3f0fc7635a88cc3d35f8f"
                    ],
                    [
                        "items/3[]/history",
                        []
                    ],
                    [
                        "items/4[]",
                        {}
                    ],
                    [
                        "items/4[]/id",
                        15208925724994
                    ],
                    [
                        "items/4[]/admin_graphql_api_id",
                        "gid://shopify/LineItem/15208925724994"
                    ],
                    [
                        "items/4[]/attributed_staffs",
                        []
                    ],
                    [
                        "items/4[]/fulfillable_quantity",
                        1
                    ],
                    [
                        "items/4[]/fulfillment_service",
                        "manual"
                    ],
                    [
                        "items/4[]/fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/4[]/gift_card",
                        false
                    ],
                    [
                        "items/4[]/grams",
                        250
                    ],
                    [
                        "items/4[]/name",
                        "X01 - Adjusted for Heat (X01)"
                    ],
                    [
                        "items/4[]/price",
                        "89.00"
                    ],
                    [
                        "items/4[]/price_set",
                        {}
                    ],
                    [
                        "items/4[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/4[]/price_set/shop_money/amount",
                        "89.00"
                    ],
                    [
                        "items/4[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/4[]/price_set/presentment_money/amount",
                        "89.00"
                    ],
                    [
                        "items/4[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/product_exists",
                        true
                    ],
                    [
                        "items/4[]/product_id",
                        8465414357314
                    ],
                    [
                        "items/4[]/product_type",
                        "Perfume"
                    ],
                    [
                        "items/4[]/properties",
                        []
                    ],
                    [
                        "items/4[]/properties/0[]",
                        {}
                    ],
                    [
                        "items/4[]/properties/0[]/name",
                        "THIS IS A GIFT"
                    ],
                    [
                        "items/4[]/properties/0[]/value",
                        "No"
                    ],
                    [
                        "items/4[]/requires_shipping",
                        true
                    ],
                    [
                        "items/4[]/sku",
                        "TLC01"
                    ],
                    [
                        "items/4[]/taxable",
                        true
                    ],
                    [
                        "items/4[]/title",
                        "X01"
                    ],
                    [
                        "items/4[]/total_discount",
                        "0.00"
                    ],
                    [
                        "items/4[]/total_discount_set",
                        {}
                    ],
                    [
                        "items/4[]/total_discount_set/shop_money",
                        {}
                    ],
                    [
                        "items/4[]/total_discount_set/shop_money/amount",
                        "0.00"
                    ],
                    [
                        "items/4[]/total_discount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/total_discount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/4[]/total_discount_set/presentment_money/amount",
                        "0.00"
                    ],
                    [
                        "items/4[]/total_discount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/variant_id",
                        46421151056194
                    ],
                    [
                        "items/4[]/variant_inventory_management",
                        "shopify"
                    ],
                    [
                        "items/4[]/variant_title",
                        "Adjusted for Heat (X01)"
                    ],
                    [
                        "items/4[]/vendor",
                        "BestPerfume.Store"
                    ],
                    [
                        "items/4[]/tax_lines",
                        []
                    ],
                    [
                        "items/4[]/tax_lines/0[]",
                        {}
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price",
                        "7.04"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/rate",
                        0.09
                    ],
                    [
                        "items/4[]/tax_lines/0[]/title",
                        "GST"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set",
                        {}
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/shop_money",
                        {}
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/shop_money/amount",
                        "7.04"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/presentment_money",
                        {}
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/presentment_money/amount",
                        "7.04"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/price_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/tax_lines/0[]/channel_liable",
                        false
                    ],
                    [
                        "items/4[]/duties",
                        []
                    ],
                    [
                        "items/4[]/discount_allocations",
                        []
                    ],
                    [
                        "items/4[]/discount_allocations/0[]",
                        {}
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount",
                        "3.75"
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set",
                        {}
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/shop_money",
                        {}
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/shop_money/amount",
                        "3.75"
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/shop_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/presentment_money",
                        {}
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/presentment_money/amount",
                        "3.75"
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/amount_set/presentment_money/currency_code",
                        "SGD"
                    ],
                    [
                        "items/4[]/discount_allocations/0[]/discount_application_index",
                        0
                    ],
                    [
                        "items/4[]/image",
                        {}
                    ],
                    [
                        "items/4[]/image/id",
                        42032825467202
                    ],
                    [
                        "items/4[]/image/position",
                        1
                    ],
                    [
                        "items/4[]/image/product_id",
                        8465414357314
                    ],
                    [
                        "items/4[]/image/width",
                        1300
                    ],
                    [
                        "items/4[]/image/height",
                        1300
                    ],
                    [
                        "items/4[]/image/alt",
                        null
                    ],
                    [
                        "items/4[]/image/src",
                        "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x01.png?v=1692971586"
                    ],
                    [
                        "items/4[]/image/created_at",
                        "2023-07-19T09:01:38+08:00"
                    ],
                    [
                        "items/4[]/image/updated_at",
                        "2023-08-25T21:53:06+08:00"
                    ],
                    [
                        "items/4[]/image/admin_graphql_api_id",
                        "gid://shopify/ProductImage/42032825467202"
                    ],
                    [
                        "items/4[]/image/variant_ids",
                        []
                    ],
                    [
                        "items/4[]/quantity",
                        1
                    ],
                    [
                        "items/4[]/picked_quantity",
                        0
                    ],
                    [
                        "items/4[]/delivered_quantity",
                        0
                    ],
                    [
                        "items/4[]/return_quantity",
                        0
                    ],
                    [
                        "items/4[]/lmd_fulfillable_quantity",
                        0
                    ],
                    [
                        "items/4[]/lmd_fulfillment_status",
                        "UNFULFILLED"
                    ],
                    [
                        "items/4[]/item_status",
                        "ACTIVE"
                    ],
                    [
                        "items/4[]/picked_up",
                        false
                    ],
                    [
                        "items/4[]/_id",
                        "66d3f0fc7635a88cc3d35f91"
                    ],
                    [
                        "items/4[]/history",
                        []
                    ],
                    [
                        "managed_by",
                        "SCROLL_ENGINE"
                    ],
                    [
                        "order_placed_date",
                        "2024-09-01T04:43:34.000Z"
                    ],
                    [
                        "shipment_assigned",
                        false
                    ],
                    [
                        "shipment_status",
                        "NEW"
                    ],
                    [
                        "suggested_shipment_location",
                        []
                    ],
                    [
                        "transfer_type",
                        "LAST_MILE"
                    ],
                    [
                        "updatedAt",
                        "2024-09-01T04:43:40.552Z"
                    ]
                ],
                "removed": [],
                "edited": []
            },
            "restore_metadata": [
                {
                    "type": "add",
                    "key": "start_location",
                    "value": {
                        "shipment_location": "647f51a1f8469eddb58acbe5"
                    }
                },
                {
                    "type": "add",
                    "key": "end_location",
                    "value": {
                        "order_location": {
                            "title": "Customer's default",
                            "latLng": "1.429532,103.7974626",
                            "lat": "1.429532",
                            "lng": "103.7974626"
                        }
                    }
                },
                {
                    "type": "add",
                    "key": "delivery_timeslot",
                    "value": {
                        "title": "",
                        "date": null,
                        "start": 0,
                        "end": 1440
                    }
                },
                {
                    "type": "add",
                    "key": "_id",
                    "value": "66d3f0fcd5945fb6637d9a4c"
                },
                {
                    "type": "add",
                    "key": "order",
                    "value": "66d3f0fc7635a88cc3d35f89"
                },
                {
                    "type": "add",
                    "key": "tenant_id",
                    "value": "647f5198df12d9c3626610e2"
                },
                {
                    "type": "add",
                    "key": "__v",
                    "value": 0
                },
                {
                    "type": "add",
                    "key": "action_needed",
                    "value": false
                },
                {
                    "type": "add",
                    "key": "awb_no",
                    "value": "O5WZAPUCB7"
                },
                {
                    "type": "add",
                    "key": "claimable",
                    "value": false
                },
                {
                    "type": "add",
                    "key": "createdAt",
                    "value": "2024-09-01T04:43:34.000Z"
                },
                {
                    "type": "add",
                    "key": "delivery_metadata",
                    "value": {
                        "delivery_date": null,
                        "pincode": "",
                        "location_id": "",
                        "location_title": "",
                        "slot_id": "",
                        "slot_title": ""
                    }
                },
                {
                    "type": "add",
                    "key": "delivery_method",
                    "value": "LOCAL_DELIVERY"
                },
                {
                    "type": "add",
                    "key": "isArcheived",
                    "value": false
                },
                {
                    "type": "add",
                    "key": "items",
                    "value": [
                        {
                            "id": 15208925593922,
                            "admin_graphql_api_id": "gid://shopify/LineItem/15208925593922",
                            "attributed_staffs": [],
                            "fulfillable_quantity": 1,
                            "fulfillment_service": "manual",
                            "fulfillment_status": "UNFULFILLED",
                            "gift_card": false,
                            "grams": 250,
                            "name": "X95",
                            "price": "89.00",
                            "price_set": {
                                "shop_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "product_exists": true,
                            "product_id": 8812656689474,
                            "product_type": "Perfume",
                            "properties": [
                                {
                                    "name": "THIS IS A GIFT",
                                    "value": "No"
                                }
                            ],
                            "requires_shipping": true,
                            "sku": "TLC95",
                            "taxable": true,
                            "title": "X95",
                            "total_discount": "0.00",
                            "total_discount_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "variant_id": 47034631258434,
                            "variant_inventory_management": "shopify",
                            "variant_title": null,
                            "vendor": "BestPerfume.Store",
                            "tax_lines": [
                                {
                                    "price": "7.04",
                                    "rate": 0.09,
                                    "title": "GST",
                                    "price_set": {
                                        "shop_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "channel_liable": false
                                }
                            ],
                            "duties": [],
                            "discount_allocations": [
                                {
                                    "amount": "3.75",
                                    "amount_set": {
                                        "shop_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "discount_application_index": 0
                                }
                            ],
                            "image": {
                                "id": 42902965911874,
                                "position": 1,
                                "product_id": 8812656689474,
                                "width": 1300,
                                "height": 1300,
                                "alt": null,
                                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x95.png?v=1696268914",
                                "created_at": "2023-10-03T01:48:34+08:00",
                                "updated_at": "2023-10-03T01:48:34+08:00",
                                "admin_graphql_api_id": "gid://shopify/ProductImage/42902965911874",
                                "variant_ids": []
                            },
                            "quantity": 1,
                            "picked_quantity": 0,
                            "delivered_quantity": 0,
                            "return_quantity": 0,
                            "lmd_fulfillable_quantity": 0,
                            "lmd_fulfillment_status": "UNFULFILLED",
                            "item_status": "ACTIVE",
                            "picked_up": false,
                            "_id": "66d3f0fc7635a88cc3d35f8a",
                            "history": []
                        },
                        {
                            "id": 15208925626690,
                            "admin_graphql_api_id": "gid://shopify/LineItem/15208925626690",
                            "attributed_staffs": [],
                            "fulfillable_quantity": 1,
                            "fulfillment_service": "manual",
                            "fulfillment_status": "UNFULFILLED",
                            "gift_card": false,
                            "grams": 0,
                            "name": "FREE Luxury Refillable Atomiser",
                            "price": "0.00",
                            "price_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "product_exists": true,
                            "product_id": 8476207874370,
                            "product_type": "Gift",
                            "properties": [],
                            "requires_shipping": true,
                            "sku": "AC01",
                            "taxable": true,
                            "title": "FREE Luxury Refillable Atomiser",
                            "total_discount": "0.00",
                            "total_discount_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "variant_id": 45731893936450,
                            "variant_inventory_management": "shopify",
                            "variant_title": null,
                            "vendor": "BestPerfume.Store",
                            "tax_lines": [
                                {
                                    "price": "0.00",
                                    "rate": 0.09,
                                    "title": "GST",
                                    "price_set": {
                                        "shop_money": {
                                            "amount": "0.00",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "0.00",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "channel_liable": false
                                }
                            ],
                            "duties": [],
                            "discount_allocations": [],
                            "image": {
                                "id": 43375725936962,
                                "position": 1,
                                "product_id": 8476207874370,
                                "width": 960,
                                "height": 1080,
                                "alt": null,
                                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/luxuryperfumeatomiser.png?v=1700300379",
                                "created_at": "2023-11-18T17:39:39+08:00",
                                "updated_at": "2023-11-18T17:39:39+08:00",
                                "admin_graphql_api_id": "gid://shopify/ProductImage/43375725936962",
                                "variant_ids": []
                            },
                            "quantity": 1,
                            "picked_quantity": 0,
                            "delivered_quantity": 0,
                            "return_quantity": 0,
                            "lmd_fulfillable_quantity": 0,
                            "lmd_fulfillment_status": "UNFULFILLED",
                            "item_status": "ACTIVE",
                            "picked_up": false,
                            "_id": "66d3f0fc7635a88cc3d35f8c",
                            "history": []
                        },
                        {
                            "id": 15208925659458,
                            "admin_graphql_api_id": "gid://shopify/LineItem/15208925659458",
                            "attributed_staffs": [],
                            "fulfillable_quantity": 1,
                            "fulfillment_service": "manual",
                            "fulfillment_status": "UNFULFILLED",
                            "gift_card": false,
                            "grams": 250,
                            "name": "X54",
                            "price": "89.00",
                            "price_set": {
                                "shop_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "product_exists": true,
                            "product_id": 8465409016130,
                            "product_type": "Perfume",
                            "properties": [
                                {
                                    "name": "THIS IS A GIFT",
                                    "value": "No"
                                }
                            ],
                            "requires_shipping": true,
                            "sku": "TLC54",
                            "taxable": true,
                            "title": "X54",
                            "total_discount": "0.00",
                            "total_discount_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "variant_id": 45670043615554,
                            "variant_inventory_management": "shopify",
                            "variant_title": null,
                            "vendor": "BestPerfume.Store",
                            "tax_lines": [
                                {
                                    "price": "7.04",
                                    "rate": 0.09,
                                    "title": "GST",
                                    "price_set": {
                                        "shop_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "channel_liable": false
                                }
                            ],
                            "duties": [],
                            "discount_allocations": [
                                {
                                    "amount": "3.75",
                                    "amount_set": {
                                        "shop_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "discount_application_index": 0
                                }
                            ],
                            "image": {
                                "id": 42032937959746,
                                "position": 1,
                                "product_id": 8465409016130,
                                "width": 1300,
                                "height": 1300,
                                "alt": null,
                                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x54.png?v=1689729448",
                                "created_at": "2023-07-19T09:17:28+08:00",
                                "updated_at": "2023-07-19T09:17:28+08:00",
                                "admin_graphql_api_id": "gid://shopify/ProductImage/42032937959746",
                                "variant_ids": []
                            },
                            "quantity": 1,
                            "picked_quantity": 0,
                            "delivered_quantity": 0,
                            "return_quantity": 0,
                            "lmd_fulfillable_quantity": 0,
                            "lmd_fulfillment_status": "UNFULFILLED",
                            "item_status": "ACTIVE",
                            "picked_up": false,
                            "_id": "66d3f0fc7635a88cc3d35f8d",
                            "history": []
                        },
                        {
                            "id": 15208925692226,
                            "admin_graphql_api_id": "gid://shopify/LineItem/15208925692226",
                            "attributed_staffs": [],
                            "fulfillable_quantity": 1,
                            "fulfillment_service": "manual",
                            "fulfillment_status": "UNFULFILLED",
                            "gift_card": false,
                            "grams": 250,
                            "name": "X30",
                            "price": "89.00",
                            "price_set": {
                                "shop_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "product_exists": true,
                            "product_id": 8465411506498,
                            "product_type": "Perfume",
                            "properties": [
                                {
                                    "name": "THIS IS A GIFT",
                                    "value": "No"
                                }
                            ],
                            "requires_shipping": true,
                            "sku": "TLC30",
                            "taxable": true,
                            "title": "X30",
                            "total_discount": "0.00",
                            "total_discount_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "variant_id": 45670051512642,
                            "variant_inventory_management": "shopify",
                            "variant_title": null,
                            "vendor": "BestPerfume.Store",
                            "tax_lines": [
                                {
                                    "price": "7.04",
                                    "rate": 0.09,
                                    "title": "GST",
                                    "price_set": {
                                        "shop_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "channel_liable": false
                                }
                            ],
                            "duties": [],
                            "discount_allocations": [
                                {
                                    "amount": "3.75",
                                    "amount_set": {
                                        "shop_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "discount_application_index": 0
                                }
                            ],
                            "image": {
                                "id": 42032900604226,
                                "position": 1,
                                "product_id": 8465411506498,
                                "width": 1300,
                                "height": 1300,
                                "alt": null,
                                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x30.png?v=1689729136",
                                "created_at": "2023-07-19T09:12:16+08:00",
                                "updated_at": "2023-07-19T09:12:16+08:00",
                                "admin_graphql_api_id": "gid://shopify/ProductImage/42032900604226",
                                "variant_ids": []
                            },
                            "quantity": 1,
                            "picked_quantity": 0,
                            "delivered_quantity": 0,
                            "return_quantity": 0,
                            "lmd_fulfillable_quantity": 0,
                            "lmd_fulfillment_status": "UNFULFILLED",
                            "item_status": "ACTIVE",
                            "picked_up": false,
                            "_id": "66d3f0fc7635a88cc3d35f8f",
                            "history": []
                        },
                        {
                            "id": 15208925724994,
                            "admin_graphql_api_id": "gid://shopify/LineItem/15208925724994",
                            "attributed_staffs": [],
                            "fulfillable_quantity": 1,
                            "fulfillment_service": "manual",
                            "fulfillment_status": "UNFULFILLED",
                            "gift_card": false,
                            "grams": 250,
                            "name": "X01 - Adjusted for Heat (X01)",
                            "price": "89.00",
                            "price_set": {
                                "shop_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "89.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "product_exists": true,
                            "product_id": 8465414357314,
                            "product_type": "Perfume",
                            "properties": [
                                {
                                    "name": "THIS IS A GIFT",
                                    "value": "No"
                                }
                            ],
                            "requires_shipping": true,
                            "sku": "TLC01",
                            "taxable": true,
                            "title": "X01",
                            "total_discount": "0.00",
                            "total_discount_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "SGD"
                                }
                            },
                            "variant_id": 46421151056194,
                            "variant_inventory_management": "shopify",
                            "variant_title": "Adjusted for Heat (X01)",
                            "vendor": "BestPerfume.Store",
                            "tax_lines": [
                                {
                                    "price": "7.04",
                                    "rate": 0.09,
                                    "title": "GST",
                                    "price_set": {
                                        "shop_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "7.04",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "channel_liable": false
                                }
                            ],
                            "duties": [],
                            "discount_allocations": [
                                {
                                    "amount": "3.75",
                                    "amount_set": {
                                        "shop_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        },
                                        "presentment_money": {
                                            "amount": "3.75",
                                            "currency_code": "SGD"
                                        }
                                    },
                                    "discount_application_index": 0
                                }
                            ],
                            "image": {
                                "id": 42032825467202,
                                "position": 1,
                                "product_id": 8465414357314,
                                "width": 1300,
                                "height": 1300,
                                "alt": null,
                                "src": "https://cdn.shopify.com/s/files/1/0705/6634/7074/files/x01.png?v=1692971586",
                                "created_at": "2023-07-19T09:01:38+08:00",
                                "updated_at": "2023-08-25T21:53:06+08:00",
                                "admin_graphql_api_id": "gid://shopify/ProductImage/42032825467202",
                                "variant_ids": []
                            },
                            "quantity": 1,
                            "picked_quantity": 0,
                            "delivered_quantity": 0,
                            "return_quantity": 0,
                            "lmd_fulfillable_quantity": 0,
                            "lmd_fulfillment_status": "UNFULFILLED",
                            "item_status": "ACTIVE",
                            "picked_up": false,
                            "_id": "66d3f0fc7635a88cc3d35f91",
                            "history": []
                        }
                    ]
                },
                {
                    "type": "add",
                    "key": "managed_by",
                    "value": "SCROLL_ENGINE"
                },
                {
                    "type": "add",
                    "key": "order_placed_date",
                    "value": "2024-09-01T04:43:34.000Z"
                },
                {
                    "type": "add",
                    "key": "shipment_assigned",
                    "value": false
                },
                {
                    "type": "add",
                    "key": "shipment_status",
                    "value": "NEW"
                },
                {
                    "type": "add",
                    "key": "suggested_shipment_location",
                    "value": []
                },
                {
                    "type": "add",
                    "key": "transfer_type",
                    "value": "LAST_MILE"
                },
                {
                    "type": "add",
                    "key": "updatedAt",
                    "value": "2024-09-01T04:43:40.552Z"
                }
            ],
            "updated_at": "2024-09-01T04:43:40.688Z",
            "isArcheived": false,
            "tenant_id": "647f5198df12d9c3626610e2",
            "createdAt": "2024-09-01T04:43:40.691Z",
            "updatedAt": "2024-09-01T04:43:40.691Z",
            "__v": 0
        }
    ],
    "shipment_feedback": null,
    "tracking_module": {
        "delivery_proof": false,
        "activity_timeline": true,
        "customer_rating": false,
        "delivery_date": true,
        "order_details": true,
        "promotion_banner": [
            {
                "type": "01",
                "title": "Banner 1",
                "image_url": "https://localdelivery.s3.ap-south-1.amazonaws.com/pod/5Z02RUiDBqK0H1z15lSYx_3.png",
                "redirect": "",
                "_id": "65389868838e297f670b3538"
            }
        ]
    },
    "proof_of_delivery": [],
    "custom_metadata": []
}